import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=22a00be4&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=22a00be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a00be4",
  null
  
)

export default component.exports